import React, { useState } from "react";
import { useSelector } from 'react-redux';
import { RootState } from '../Store/store';
import { shareContent } from "@mental-mint/shared-utils";
import { ButtonStylized, ButtonStylizedType } from "../ButtonStylized/ButtonStylized";
import * as Lucide from "lucide-react";

export interface ButtonShareProps {
	text?: string;
	textGeneratorFunc?: () => string;
	hideButtonText?: boolean;
    buttonType?: ButtonStylizedType;
	iconSize?: number;
    additionalStyles?: React.CSSProperties;
}

const ButtonShare: React.FC<ButtonShareProps> = ({ text, textGeneratorFunc, hideButtonText, buttonType, iconSize, additionalStyles }) => {
    // Get game data from Redux
    const { currentGame: game } = useSelector((state: RootState) => state.gameSession);
    
    const [copied, setCopied] = useState(false);

    // Early return if no game data
    if (!game) {
        return null;
    }

	let textToUse = text || (textGeneratorFunc && textGeneratorFunc()) || "Play this game!";

	// Add game URL to text if not already present
	if (!textToUse.includes(game.metadata.gameURL)) {
		textToUse += `\n${game.metadata.gameURL}`;
	}

    const handleShare = async () => {
        try {
            await shareContent({
                text: textToUse,
                analyticsMessage: "User clicked share button",
                onSuccess: () => {
                    setCopied(true);
                    setTimeout(() => setCopied(false), 2500);
                }
            });
        } catch (error) {
            // Error already logged in shareContent
        }
    };

    return (
        <ButtonStylized 
            buttonType={buttonType || ButtonStylizedType.Primary}
            onClick={handleShare}
            icon={copied ? <Lucide.Clipboard className="share-icon" size={iconSize || 27} strokeWidth={3} /> : <Lucide.Share className="share-icon" size={iconSize || 27} strokeWidth={3} />}
            additionalStyles={{fontSize:"2rem", ...additionalStyles}}
            text={hideButtonText ? "" : (copied ? "Copied" : "Share")}
        />
    );
};

export default ButtonShare;